export class PopUpModal {
    static $inject = ['$uibModal', '$timeout', '$window'];

    constructor($uibModal, $timeout, $window) {
        this.uibModal = $uibModal;
        this.popupTemplate = require('./popUpModal.tpl.html');
        this.$timeout = $timeout;
        this.$window = $window;
        this.timeoutInstanse = null;
        this.$window.addEventListener("popstate", () => { if (this.$uibModalInstance) this.dismiss(); });
    }

    dismiss() {
        if (this.$uibModalInstance)
            this.$uibModalInstance.dismiss('close the modal');
    }

    close() {
        if (this.$uibModalInstance)
            this.$uibModalInstance.close(this.data);
        // this.$uibModalInstance.dismiss('close the modal');
    }

    $onDestroy() {
        this.$timeout.cancel(this.timeoutInstanse);
    }

    open(config, onSuccess, onFailure, onClosed) {
        const _this = this;
        let uibModal = this.uibModal;
        this.data = null;
        this.popUpOpen = true;
        let modalInstance = uibModal.open({
            template: this.popupTemplate,
            windowClass: config.windowClass,
            controller: ['$uibModalInstance', 'config', function ($uibModalInstance, config) {
                _this.$uibModalInstance = $uibModalInstance;
                this.$uibModalInstance = $uibModalInstance;
                this.template = config.template;
                this.title = config.title;
                _this.data = config.contentData;
                this.data = config.contentData;
                this.customActions = config.customActions;
                this.footerClass = config.footerClass;
                if (config.customButtons && config.buttons && config.buttons.length > 0) {
                    config.buttons.forEach((item) => {
                        item.popupClick = () => {
                            item.onClick($uibModalInstance, this.data);
                        }
                    });
                    this._buttons = config.buttons;
                } else {
                    this._buttons = [{
                        text: config.buttons && config.buttons.OK && config.buttons.OK.text ? config.buttons.OK.text : "Ok",
                        klass: config.buttons && config.buttons.OK && config.buttons.OK.klass ? config.buttons.OK.klass : "",
                        popupClick: () => {
                            $uibModalInstance.close(this.data);
                        }
                    }, {
                        text: config.buttons && config.buttons.CANCEL && config.buttons.CANCEL.text ? config.buttons.CANCEL.text : "Cancel",
                        klass: config.buttons && config.buttons.CANCEL && config.buttons.CANCEL.klass ? config.buttons.CANCEL.klass : "",
                        popupClick: () => {
                            $uibModalInstance.dismiss('close the modal');
                        }
                    }];
                }
                this.popupButtons = () => {
                    return this._buttons;
                };
            }],
            controllerAs: 'vm',
            resolve: {
                config: () => {
                    return config;
                }
            },
            backdrop: 'static' //(config.isCloseFromOutside === undefined || config.isCloseFromOutside == true) ? 'true' : 'static'
        });

        modalInstance.result.then((data) => {
            if (onSuccess) {
                onSuccess(data);
            }
        }, (reason) => {
            if (onFailure) {
                onFailure(reason);
            }
            if (onClosed) {
                onClosed();
            }
        });
        //modalInstance.closed.then(() => {
        //    this.hideShepherdSteps();
        //});
        //modalInstance.opened.then(() => {
        //    this.restoreShepherdSteps();
        //})
    };
/*
    hideShepherdSteps() {
        if (Shepherd.activeTour) {
            const currentStep = Shepherd.activeTour.currentStep;
            this.timeoutInstanse = this.$timeout(() => {
                const nextStep = Shepherd.activeTour.currentStep;
                if (currentStep == nextStep && !document.querySelector(currentStep.options.attachTo.element)) {
                    currentStep.hide();
                }
            }, 50);
        }
    }

    restoreShepherdSteps() {
        const beforeShowPromise = (selector) => {
            return new Promise((resolve, reject) => {
                const interval = setInterval(() => {
                    let el = document.querySelector(selector);
                    if (el) {
                        clearInterval(interval);
                        resolve();
                    }
                }, 300);
            });
        }
        if (Shepherd.activeTour) {
            const currentStep = Shepherd.activeTour.currentStep;
            if (currentStep && !currentStep.isOpen()) {
                currentStep.options.beforeShowPromise = beforeShowPromise;
                currentStep.show();
            }
        }
    }
    */
}



// WEBPACK FOOTER //
// ./src/app/common/components/popUpModal/popUpModal.js